<template>
  <div>
    <McButton
      class="mc-btn-add-addenddum"
      variant="secondary"
      text="Ubah Data"
      icon="icon-outline_edit"
      @click="handleCreateAddendum"
    />
  </div>
</template>

<script>
import McButton from '@/components/McButton'

import * as Addendum from '@/services/rest-api/lib/contract/addendum'

export default {
  components: {
    McButton,
  },
  data() {
    return {
      isLoading: false,
    }
  },
  computed: {
    prefixUrl() {
      return {
        vendorId: this.$route.params.vendorId,
        contractId: this.$route.params.contractId,
        versionId: this.$route.params.versionId,
      }
    },
  },
  methods: {
    async handleCreateAddendum() {
      this.isLoading = true
      const res = await Addendum.create(this.prefixUrl)

      if (!res) {
        this.$mcToast.error('Terjadi kesalahan')
        this.isLoading = false
        return
      }

      this.$mcToast.success('Berhasil membuat draft addendum')

      const { vendor_id, contract_id, version_id } = res.data || {}

      this.$router.push({
        name: 'Master Vendor Contract Detail',
        params: {
          vendorId: vendor_id,
          contractId: contract_id,
          versionId: version_id,
        },
      })

      this.isLoading = false
    },
  },
}
</script>

<style lang="scss" scoped>
:deep(.mc-btn-add-addenddum) {
  white-space: nowrap;
}
</style>
